import dateService from '../services/util/dateService'
import loggingService from '../services/util/loggingService'
import _ from 'lodash/lodash.min.js'

var serviceName = 'fieldworkRequestService'
var path = '/FieldworkRequest/'
var isDebug = false

function getUrlById (fieldworkRequestId) {
    return path + fieldworkRequestId
}

function getUrlByObject (fieldworkRequest) {
    return getUrlById(fieldworkRequest.fieldworkRequestId)
}

function get (http, fieldworkRequestId) {
    return http.get(path + 'Get?fieldworkRequestId=' + fieldworkRequestId).then(response => {
        if (response.data.workTypeList) {
            response.data.rawWorkTypeList = response.data.workTypeList.split(', ')
        }
        return response
    })
}

function put (http, fieldworkRequest) {
    loggingService.log(isDebug, serviceName, 'put')
    if (fieldworkRequest.rawWorkTypeList) {
        fieldworkRequest.workTypeList = fieldworkRequest.rawWorkTypeList.join(', ')
    }

    fieldworkRequest.dateRequestedOfLeadAgency = dateService.convertToDate(fieldworkRequest.dateRequestedOfLeadAgency)
    fieldworkRequest.dateOfLeadAgencyDecision = dateService.convertToDate(fieldworkRequest.dateOfLeadAgencyDecision)

    return http.put(path, fieldworkRequest)
}

function search (http, fieldworkRequestSearchDto) {
    loggingService.log(isDebug, serviceName, 'search')
    return http.post(path + 'Search', fieldworkRequestSearchDto).then(function (response) {
        loggingService.log(isDebug, serviceName, 'search.then')

        _.forEach(response.data, function (value, key) {
            value.createdDate = dateService.convertToDate(value.createdDate)
            value.proposedStartDate = dateService.convertToDate(value.proposedStartDate)
            value.proposedEndDate = dateService.convertToDate(value.proposedEndDate)
            value.dateRequestedOfLeadAgency = dateService.convertToDate(value.dateRequestedOfLeadAgency)
            value.dateOfLeadAgencyDecision = dateService.convertToDate(value.dateOfLeadAgencyDecision)
            value.submitDate = dateService.convertToDate(value.submitDate)
            value.workflowStatusDate = dateService.convertToDate(value.workflowStatusDate)
        })

        return response
    })
}

function todo (http, fieldworkRequestSearchDto) {
    loggingService.log(isDebug, serviceName, 'todo')
    return http.post(path + 'Todo', fieldworkRequestSearchDto).then(function (response) {
        loggingService.log(isDebug, serviceName, 'todo.then')

        _.forEach(response.data, function (value, key) {
            value.createdDate = dateService.convertToDate(value.createdDate)
            value.proposedStartDate = dateService.convertToDate(value.proposedStartDate)
            value.proposedEndDate = dateService.convertToDate(value.proposedEndDate)
            value.dateRequestedOfLeadAgency = dateService.convertToDate(value.dateRequestedOfLeadAgency)
            value.dateOfLeadAgencyDecision = dateService.convertToDate(value.dateOfLeadAgencyDecision)
            value.submitDate = dateService.convertToDate(value.submitDate)
        })

        return response
    })
}

function listFieldworkRequestCountyList (http, fieldworkRequestId) {
    loggingService.log(isDebug, serviceName, 'loadFieldworkRequestCountyList')

    return http.get(path + 'ListCountyDto?fieldworkRequestId=' + fieldworkRequestId).then(function (response) {
        _.forEach(response.data, function (value, key) {
            value.createdDate = dateService.convertToDate(value.createdDate)
        })

        return response
    })
}

function listFieldworkRequestMapReferenceList (http, fieldworkRequestId) {
    loggingService.log(isDebug, serviceName, 'loadFieldworkRequestMapReferenceList')

    return http.get(path + 'ListMapReferenceDto?fieldworkRequestId=' + fieldworkRequestId).then(function (response) {
        _.forEach(response.data, function (value, key) {
            value.createdDate = dateService.convertToDate(value.createdDate)
        })

        return response
    })
}

function addCounty (http, fieldworkRequestId, countyId) {
    loggingService.log(isDebug, serviceName, 'addCounty')

    var data = {
        fieldworkRequestId: fieldworkRequestId,
        countyId: countyId
    }

    return http.post(path + 'AddCounty', data)
}

function deleteCounty (http, fieldworkRequestId, countyId) {
    loggingService.log(isDebug, serviceName, 'deleteCounty')

    var data = {
        fieldworkRequestId: fieldworkRequestId,
        countyId: countyId
    }

    return http.post(path + 'DeleteCounty', data)
}

function addMapReference (http, fieldworkRequestId, mapReferenceId) {
    loggingService.log(isDebug, serviceName, 'addMapReference')

    var data = {
        fieldworkRequestId: fieldworkRequestId,
        mapReferenceId: mapReferenceId
    }

    return http.post(path + 'AddMapReference', data)
}

function deleteMapReference (http, fieldworkRequestId, mapReferenceId) {
    loggingService.log(isDebug, serviceName, 'deleteMapReference')

    var data = {
        fieldworkRequestId: fieldworkRequestId,
        mapReferenceId: mapReferenceId
    }

    return http.post(path + 'DeleteMapReference', data)
}

function listFieldworkRequestPlssLocationResultDto (http, fieldworkRequestId) {
    loggingService.log(isDebug, serviceName, 'listFieldworkRequestPlssLocationResultDto')

    return http.get(path + 'ListFieldworkRequestPlssLocationResultDto?fieldworkRequestId=' + fieldworkRequestId).then(function (response) {
        _.forEach(response.data, function (value, key) {
            value.createdDate = dateService.convertToDate(value.createdDate)
            value.modifiedDate = dateService.convertToDate(value.modifiedDate)
        })

        return response
    })
}

function listByProjectId (http, projectId) {
    loggingService.log(isDebug, serviceName, 'listByProjectId')

    return http.get(path + 'listByProjectId?projectId=' + projectId).then(function (response) {
        _.forEach(response.data, function (value, key) {
            value.proposedStartDate = dateService.convertToDate(value.proposedStartDate)
            value.proposedEndDate = dateService.convertToDate(value.proposedEndDate)
            value.createdDate = dateService.convertToDate(value.createdDate)
            value.modifiedDate = dateService.convertToDate(value.modifiedDate)
        })

        return response
    })
}

function putPlss (http, fieldworkRequestId, plss) {
    loggingService.log(isDebug, serviceName, 'putPlss - fieldworkRequestId: ' + fieldworkRequestId + ', plss: ' + plss)

    var data = {
        parentId: fieldworkRequestId,
        parentType: 'FieldworkRequest',
        plssLocation: plss,
        sections: plss.Sections
    }

    return http.put(path + 'PutPlss', data)
}

function deletePlssLocation (http, fieldworkRequestPlssLocationId) {
    loggingService.log(isDebug, serviceName, 'deletePlssLocation, fieldworkRequestPlssLocationId: ' + fieldworkRequestPlssLocationId)
    return http.get(path + 'deletePlss?fieldworkRequestPlssLocationId=' + fieldworkRequestPlssLocationId)
}

function fieldworkRequestReportGen (http, fwrId) {
    return http.get(path + `FieldworkRequestReportGen?fieldworkRequestId=${fwrId}`, { responseType: 'arraybuffer' })
}

function deleteFieldworkRequest (http, fieldworkRequestId) {
    loggingService.log(isDebug, serviceName, 'deleteFieldworkRequest, fieldworkRequestId: ' + fieldworkRequestId)
    return http.delete(path + 'deleteFieldworkRequest?fieldworkRequestId=' + fieldworkRequestId)
}

export default {
    get: get,
    put: put,
    search: search,
    todo: todo,
    listFieldworkRequestCountyList: listFieldworkRequestCountyList,
    listFieldworkRequestMapReferenceList: listFieldworkRequestMapReferenceList,
    addCounty: addCounty,
    deleteCounty: deleteCounty,
    addMapReference: addMapReference,
    deleteMapReference: deleteMapReference,
    listFieldworkRequestPlssLocationResultDto: listFieldworkRequestPlssLocationResultDto,
    listByProjectId: listByProjectId,
    getUrlById: getUrlById,
    getUrlByObject: getUrlByObject,
    putPlss: putPlss,
    deletePlssLocation: deletePlssLocation,
    fieldworkRequestReportGen: fieldworkRequestReportGen,
    deleteFieldworkRequest: deleteFieldworkRequest
}



// WEBPACK FOOTER //
// ./src/services/fieldworkRequestService.js